import { render, staticRenderFns } from "./MessageSenderCard.vue?vue&type=template&id=4880433f&scoped=true&"
import script from "./MessageSenderCard.vue?vue&type=script&lang=js&"
export * from "./MessageSenderCard.vue?vue&type=script&lang=js&"
import style0 from "./MessageSenderCard.vue?vue&type=style&index=0&id=4880433f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4880433f",
  null
  
)

export default component.exports